module.exports = __webpack_public_path__ + "img/negative-impact.6f6a8a70.svg";